import { render, staticRenderFns } from "./TheAddTodo.vue?vue&type=template&id=53ff0a73&"
import script from "./TheAddTodo.vue?vue&type=script&lang=js&"
export * from "./TheAddTodo.vue?vue&type=script&lang=js&"
import style0 from "./TheAddTodo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports